import { Alert } from '@material-ui/lab';
import { Collection, Events } from '@type-r/models';
import { Linked, useLinked, useModel } from '@type-r/react';
import { CompanyModel, PlatformCompany } from 'api';
import { AppLink, PopupIODialog } from 'lqx-react';
import * as React from 'react';
import { RecsInvoice } from '../api/invoice';
import { RemittanceAdvice } from '../api/remittance-advice';
import { RemittanceAdviceContent } from '../remittance/details';

export const CreateRADialog = ({ $isOpen, companies, invoices, onSuccess, onRACreated, withAppLink }: {
    $isOpen: Linked<boolean>,
    companies: Collection<PlatformCompany>,
    invoices?: Collection<RecsInvoice>,
    onSuccess?: () => void;
    onRACreated?: (remittanceAdvice) => void;
    withAppLink?: boolean
}) => {
    const remittanceAdvice = useModel(RemittanceAdvice);
    const $isDisabled = useLinked(false);

    const $file = useLinked(null);

    const validInvoices = !invoices || invoices.every(inv => inv.currency === invoices.first().currency);

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title="Create Remittance Advice"
            actionLabel="Confirm"
            maxWidth="lg"
            success={<>Remittance Advice created
                {withAppLink ?
                    <AppLink href={`/remittance-advices/details/${remittanceAdvice.id}`}> #{remittanceAdvice.id}</AppLink> :
                    ` #${remittanceAdvice.id}`
                }
            </>}
            disabled={$isDisabled.value || !validInvoices}
            doIO={async () => {

                await remittanceAdvice.save({ params: { file: $file.value } });
                if (onRACreated) {
                    onRACreated(remittanceAdvice);
                }
                Events.trigger('futureInvoicesSummary:refresh');
            }}
            onSuccess={onSuccess}
        >
            {validInvoices ?
                <RemittanceAdviceContent
                    remittanceAdvice={remittanceAdvice}
                    companies={companies}
                    $editButtonClicked={useLinked(false)}
                    $isDisabled={$isDisabled}
                    invoices={invoices}
                    $file={$file}
                /> : <Alert severity="error">Not allowed to create RA with invoices in different currencies. Please make another selection.</Alert>
            }
        </PopupIODialog>)
}
